<template>
  <div class="container_box">
    <!--扫描区域-->
    <div class="scanning_conter_box">
      <!--扫描包裹-->
      <div class="package_box">
        <div class="options_box">
          <Form :model="formParameter" ref="formParameter" class="form_box" :label-width="80" @submit.native.prevent>
            <!--扫描 已换单的云卖订单可以操作-->
            <FormItem :label="$t('key1004003')" prop="scanningInput">
              <Input
                v-model.trim="formParameter.scanningInput"
                :element-id="'scanningInput'"
                style="width:350px"
                :placeholder="$t('key1004004')"
                @on-keyup.13="scanningKey(1)"></Input>
            </FormItem>
            <!--称重-->
            <FormItem :label="$t('key1004005')" prop="weight" v-if="enableWeightTalg">
              <Input v-model.trim="formParameter.weight"
                type="number"
                style="width:350px"
                :element-id="'weight'"
                number
                :maxlength="15"
                @on-keyup.13="scanningKey(2)">
                <template #append>{{ weightUnitTxt }}</template>
              </Input>
            </FormItem>
          </Form>
          <div class="scanning_conter_header">
            <div class="options_center">
              <div class="options">
                <!--称重-->
                <div class="options_item">
                  <span class="txt">{{ $t('key1004009') }}</span>
                  <Icon :class="enableWeightTalg ? 'icon_yes' : 'icon_no'"
                    :type="enableWeightTalg ? 'md-checkmark' : 'md-close'"/>
                </div>
                <!--称重单位-->
                <div class="options_item">
                  <span class="txt">{{ weightTitle }}</span>
                  <Tooltip transfer max-width="300" :content="$t('key1004006')">
                    <Icon class="help_icon" type="md-help-circle"></Icon>
                  </Tooltip>
                </div>
                <!--设置-->
                <div class="options_item" v-if="getPermission('erpCommonSettingParam_save')">
                  <Icon
                    class="icon_set"
                    type="md-settings"
                    style="position: relative; top: -2px;"
                    @click="setingBtn"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--物流方式-->
        <div>
          <div class="logistics_mode">
            <span class="tips">{{ $t('key1004010') }}</span>
            <span class="text">{{ logisticsMode }}</span>
          </div>
          <div class="scan_title">{{ $t('key1001521') + waybillNo }}</div>
          <div class="scan_title" v-if="enableWeightTalg">
            {{ $t('key1004007') + weightUnitTxt + ')：' + (formParameter.weight ? formParameter.weight : '') }}
          </div>
        </div>
        <!--容器编号-->
        <Card dis-hover style="height:340px; position: relative;" v-if="containerCode">
          <template #title><h2 class="title_box">{{ $t('key1002400') + containerCode }}</h2></template>
          <div class="table-box">
            <Table
              highlight-row
              border
              max-height="200"
              :loading="tableLoading"
              :columns="containerColumns"
              :data="containerData">
            </Table>
          </div>
          <div class="end_sort_btn">
            <Button style="width: 100%" type="primary"
              :disabled="containerData.length<=0 && getPermission('ymsContainer_closeContainerSorting')"
              @click="endContainerSortingBtn">{{ $t('key1004011') }}
            </Button>
          </div>
        </Card>
      </div>
    </div>
    <!--列表区域 -->
    <div class="tabs_conter_box" v-show="oeliveryOrderData.length >0">
      <Tabs type="card" v-model="tabsName" :animated="false" @on-click="changeTabs">
        <TabPane v-for="(item, index) in oeliveryOrderData"
          :key="index"
          :label="(h)=>{
            return h('div',[
              h('p',item.carrierName),
              h('p',{class: 'font-size-12'},item.shippingMethodName)
            ])
          }"
          :name="item.orderType === 'ONE_STOP_SERVICE' && item.carrierCode === 'aliexpressChoice' ? item.ymsPlatformAccountId : item.shippingMethodId">
          <!--使用订单地址-->
          <template v-if="item.deliveryAddressType === 2">
            <div class="orderAddress_tab_box">
              <span class="orderAddress_tab_item" v-for="(ele,idx) in item.orderAddressData" @click="orderAddressChange(ele, index)"
                :class="item.orderAddressTab === ele.ymsCarrierHandoverOrderId ?'active_tab': ''">
                {{ $t('key1004008') + (idx + 1) }}
              </span>
            </div>
            <template v-for="ele in item.orderAddressData" v-if="item.orderAddressTab === ele.ymsCarrierHandoverOrderId">
              <Table highlight-row border max-height="550" :columns="oeliveryOrderColumns" :data="ele.addressList"></Table>
            </template>
          </template>
          <template v-else>
            <Table highlight-row border max-height="550" :columns="oeliveryOrderColumns" :data="item.data"></Table>
          </template>
        </TabPane>
      </Tabs>
      <Button type="success" size="large" class="options_btn"
        v-if="getPermission('ymsCarrierHandoverOrder_packageBagging')" @click="bagMakingBtn">{{ $t('key1004012') }}</Button>
    </div>
    <!--发货设置弹窗-->
    <shipmentSettingsModal ref="shipmentSettings" @updateData="getDeliverySettings()"></shipmentSettingsModal>
    <!--订单取消提示-->
    <orderCancelPromptModal
      ref="orderCancelPrompt"
      :continueSort="continueSort"
      :btnStatus="btnStatus"
      @continueSortingFun="scanningPackageData()">
    </orderCancelPromptModal>
    <!--预交面单的提示弹窗-->
    <Modal v-model="preDeliverySheetModal" :transfer="false" :mask-closable="false" :closable="false" footer-hide>
      <div class="flex mb20 align-items-center">
        <Icon type="md-alert" color="#02A7F0" size="28"/>
        <h2 class="font-weight-bold ml5" style="font-size: 16px;">{{ $t('key1004013') }}</h2>
      </div>
      <p style="margin-left: 33px;">{{ $t('key1004014') }}</p>
      <div class="flex align-items-center justify-content-end mt20" style="width: 100%; padding: 12px 18px 12px 18px;">
        <Button class="ml12" @click="preDeliverySheetModal = false">{{ $t('key1004015') }}</Button>
        <Button v-if="getPermission('ymsCarrierHandoverOrder_direct_packageBagging')"
          class="ml12" @click="handleBagMaking(1)">{{ $t('key1004016') }}</Button>
        <Button class="ml12" type="primary" @click="handleBagMaking(0)">{{ $t('key1004017') }}</Button>
      </div>
    </Modal>
    <!--打印揽收面单的提示弹窗-->
    <Modal v-model="aliExpressFullCustodyModal" :transfer="false" :mask-closable="false" :closable="false" footer-hide>
      <div class="flex mb20 align-items-center">
        <Icon type="md-alert" color="#02A7F0" size="28"/>
        <h2 class="font-weight-bold ml5" style="font-size: 16px;">{{ $t('key1004018') }}</h2>
      </div>
      <p style="margin-left: 33px;">{{ $t('key1004019') }}</p>
      <div class="flex align-items-center justify-content-end mt20" style="width: 100%; padding: 12px 18px 12px 18px;">
        <Button class="ml12" @click="aliExpressFullCustodyModal = false">{{ $t('key1004015') }}</Button>
        <Button v-if="getPermission('ymsCarrierHandoverOrder_direct_packageBagging')"
          class="ml12" @click="handleBagMaking(1)">{{ $t('key1004016') }}</Button>
        <Button class="ml12" type="primary" @click="handleBagMaking(0)">{{ $t('key1004020') }}</Button>
      </div>
    </Modal>
    <!--国内快递选择弹窗-->
    <domesticCourierSelectModal ref="domesticCourierSelect" @updateEndPacking="updateEndPacking"></domesticCourierSelectModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from '@/components/mixin/common_mixin';
import orderCancelPromptModal from "@/components/common/orderCancelPromptModal";
import domesticCourierSelectModal from "@/views/yms/components/collectionManage/domesticCourierSelectModal";
import {getCommonSetting, getQueryCarrierShippingName, isValueEmpty, setConfigCharacters} from "@/utils/common";
import shipmentSettingsModal from "@/views/yms/components/collectionManage/shipmentSettingsModal";

export default {
  name: "onventionalSorting",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      enableWeightTalg: false, // 是否需要称重
      weightUnitTxt: 'g', // 重量单位
      weightUnitTalg: '',
      formParameter: {
        scanningInput: '',
        weight: null
      },
      weightTitle: '',
      oeliveryOrderList: [],
      oeliveryOrderData: [],
      oeliveryOrderColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'),
          key: 'packageCode',
          minWidth: 160,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          minWidth: 160,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000854'),
          key: 'userWeight',
          minWidth: 100,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220'),
          key: 'carrierName',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let text = params.row.carrierName || '-';
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000222'),
          key: 'shippingMethodName',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let text = params.row.shippingMethodName || '-';
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'operation',
          align: 'center',
          minWidth: 180,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000402'),
                    show: true,
                    clickFn: () => {
                      v.$Modal.confirm({
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003989'),
                        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003990'),
                        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000402'),
                        loading: true,
                        onOk: () => {
                          v.removePackage(params.row);
                        }
                      });
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      supplierMerchantId: null,
      waybillNo: '', // 运单号
      logisticsMode: '', // 物流方式
      ymsPackageId: null,
      tabsName: '',
      scanData: [], // 记录已经扫描成功的数据
      ymsPickupOrderId: null,
      outboundOrder: '',
      containerColumns: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`,
          key: 'packageCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003991'),
          key: 'quantity',
          align: 'center',
          render(h, params) {
            let isScanning = params.row.isScan === 1;
            let text = '';
            if (isScanning) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002554');
            } else {
              text = params.row.scanQuantity;
            }
            return h('span', {
              style: {
                color: isScanning ? '#52C41A' : ''
              }
            }, text);
          }
        }
      ],
      containerData: [],
      containerCode: '',
      ymsCarrierHandoverOrderId: null,
      btnStatus: false,
      continueSort: false,
      carrierCode: null,
      preDeliverySheetModal: false,
      aliExpressFullCustodyModal: false,
      deliveryType: null, // 交货方式{1 快递至揽收点 2 上门揽收}
      aliExpressLogisticsInfo: {},
      ymsCarrierHandoverOrderData: {},
      scannTalg: false,
      shipmentSetObj: {}
    };
  },
  mounted() {
    let v = this;
    v.$nextTick(() => {
      v.getFocus('scanningInput');
    });
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  created() {
    this.getDeliverySettings();
    this.querySortingContainer(true);
  },
  methods: {
    // 移除包裹
    async removePackage(rowData) {
      let orderType = rowData.orderType;
      let carrierCode = rowData.carrierCode;
      let detailsId = null;
      let ymsCarrierHandoverOrderId = null;
      let ymsCarrierHandoverOrderDetailIds = [];
      if (orderType === 'ONE_STOP_SERVICE' && carrierCode === 'aliexpressChoice') {
        detailsId = rowData.ymsCarrierHandoverOrderDetails.filter(i => i.packageCode === rowData.packageCode);
        ymsCarrierHandoverOrderId = rowData.ymsCarrierHandoverOrderId;
      } else {
        let row = this.oeliveryOrderData.filter(i => i.shippingMethodId === this.tabsName)[0];
        detailsId = row.ymsCarrierHandoverOrderDetails.filter(i => i.packageCode === rowData.packageCode);
        ymsCarrierHandoverOrderId = row.ymsCarrierHandoverOrderId;
      }
      if (detailsId && detailsId.length) {
        ymsCarrierHandoverOrderDetailIds = [detailsId[0].ymsCarrierHandoverOrderDetailId];
      }
      let query = {
        ymsCarrierHandoverOrderId: ymsCarrierHandoverOrderId,
        ymsCarrierHandoverOrderDetailIds: ymsCarrierHandoverOrderDetailIds
      };
      const {data} = await this.axios.post(api.post_ymsCarrierHandoverOrder_removePackage, query);
      if (data.code === 0) {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003992'));
        this.$Modal.remove();
        this.querySortingCarrierHandoverOrder();
      }
    },
    // 获取发货设置的数据
    getDeliverySettings() {
      let v = this;
      return new Promise((resolve) => {
        v.enableWeightTalg = false;
        v.weightUnitTxt = 'g';
        let query = [
          {
            paramKeys: ['enableWeight', 'weightUnit', 'beforeInterception', 'afterInterception'],
            businessId: v.userInfo.userId
          }
        ];
        getCommonSetting(query).then((data) => {
          if (data.length > 0) {
            data.forEach(item => {
              for (let key in this.$refs['shipmentSettings'].shipmentSettingsForm) {
                if (item.paramKey === key) {
                  if (['beforeInterception', 'afterInterception'].includes(item.paramKey)) {
                    v.shipmentSetObj[item.paramKey] = item.paramValue > 0 ? Number(item.paramValue) : null;
                  } else {
                    v.shipmentSetObj[item.paramKey] = item.paramValue;
                  }
                }
              }
            });
            let talg = v.shipmentSetObj.weightUnit === 'g' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003993') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003994');
            this.weightTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003995') + talg + '（' + v.shipmentSetObj.weightUnit + '）';
            this.weightUnitTxt = v.shipmentSetObj.weightUnit;
            this.enableWeightTalg = ['Y', 'YES'].includes(v.shipmentSetObj.enableWeight);
          } else {
            v.shipmentSetObj = {};
          }
          resolve(data);
        });
      }).catch(() => {
        v.shipmentSetObj = {};
      });
    },
    // 扫描包裹的方法
    scanningPackageData() {
      let v = this;
      v.scannTalg = true;
      return new Promise((resolve) => {
        v.axios.put(api.put_ymsCarrierHandoverOrder_startSorting + `${v.outboundOrder}?supplierMerchantId=${v.supplierMerchantId}`, null
          , {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.ymsCarrierHandoverOrderData = data;
            if (data.ymsCarrierHandoverOrderId) {
              // 扫描容器是没有结袋id的
              v.ymsCarrierHandoverOrderId = data.ymsCarrierHandoverOrderId;
            }
            if (Object.keys(v.shipmentSetObj).length > 0 && v.shipmentSetObj.enableWeight === 'N') {
              v.formParameter.scanningInput = '';
            }
            // 判断当前扫描的是否容器
            if (data.code) {
              if (data.ymsCarrierHandoverOrderId) {
                if (data.ymsPackageInfoList) {
                  data.ymsPackageInfoList.map((item) => {
                    item.ymsCarrierHandoverOrderId = data.ymsCarrierHandoverOrderId;
                    if (item.trackingNumber === v.outboundOrder || item.packageCode === v.outboundOrder) {
                      v.waybillNo = item.trackingNumber;
                      v.ymsPackageId = item.ymsPackageId;
                      v.logistics(item).then((logisticsProviderData) => {
                        if (Object.keys(v.shipmentSetObj).length > 0 && v.shipmentSetObj.enableWeight === 'Y') {
                          v.$nextTick(() => {
                            v.getFocus('weight');
                          });
                        } else {
                          v.handlerPackage([item], data.ymsCarrierHandoverOrderId, data, logisticsProviderData);
                        }
                      });
                    }
                  });
                }
              }
            } else {
              if (data.ymsPackageInfoList) {
                let list = data.ymsPackageInfoList[0];
                list['ymsCarrierHandoverOrderId'] = data.ymsCarrierHandoverOrderId;
                v.waybillNo = list.trackingNumber;
                v.ymsPackageId = list.ymsPackageId;
                v.logistics(list).then((logisticsProviderData) => {
                  if (Object.keys(v.shipmentSetObj).length > 0 && v.shipmentSetObj.enableWeight === 'Y') {
                    v.$nextTick(() => {
                      v.getFocus('weight');
                    });
                  } else {
                    v.handlerPackage(data.ymsPackageInfoList, data.ymsCarrierHandoverOrderId, data, logisticsProviderData);
                  }
                });
              }
            }
            v.querySortingContainer(false);
            resolve(v.ymsPackageId);
          } else {
            v.formParameter.scanningInput = '';
          }
        });
      });
    },
    // 扫描包裹的回车键
    scanningKey(value) {
      let v = this;

      function inputValue() {
        let outboundOrder = v.formParameter.scanningInput;
        let text = '';
        if (v.shipmentSetObj.beforeInterception || v.shipmentSetObj.afterInterception) {
          if (v.shipmentSetObj.beforeInterception) {
            text = outboundOrder.substring(v.shipmentSetObj.beforeInterception);
          }
          if (v.shipmentSetObj.afterInterception) {
            text = outboundOrder.substring(0, outboundOrder.length - v.shipmentSetObj.afterInterception);
          }
          if (v.shipmentSetObj.beforeInterception && v.shipmentSetObj.afterInterception) {
            text = outboundOrder.substring(v.shipmentSetObj.beforeInterception, outboundOrder.length - v.shipmentSetObj.afterInterception);
          }
        } else {
          text = outboundOrder;
        }
        return text;
      }

      let text = inputValue();
      v.outboundOrder = text;
      // 扫描包裹
      if (value === 1) {
        if (v.getPermission('ymsPackageInfo_scanPackage')) {
          setTimeout(() => {
            v.formParameter.scanningInput = text;
          }, 100);
          if (text !== '') {
            v.ymsCarrierHandoverOrderId = null;
            v.calibrationPackage().then(() => {
              if (Object.keys(v.shipmentSetObj).length > 0 && v.shipmentSetObj.enableWeight === 'Y') {
                v.$nextTick(() => {
                  v.getFocus('weight');
                });
              } else {
                v.scanningPackageData();
              }
            });
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003996'));
            return false;
          }
        } else {
          v.gotoError();
        }
      }
      // 称重
      else if (value === 2) {
        let weigth = v.formParameter.weight || '';

        function handleFun() {
          let query = {
            weight: weigth,
            weightUnit: v.weightUnitTxt === 'g' ? 0 : 1,
            ymsPackageId: v.ymsPackageId
          };
          v.scannTalg = false;
          v.axios.put(api.put_ymsPackageInfo_packingWeighting, query).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              v.ymsCarrierHandoverOrderId = data.ymsCarrierHandoverOrderId;
              v.formParameter.scanningInput = '';
              v.formParameter.weight = null;
              v.handlerPackage([data], data.ymsCarrierHandoverOrderId, v.ymsCarrierHandoverOrderData);
              v.$forceUpdate();
              v.$nextTick(() => {
                v.getFocus('scanningInput');
              });
            }
          });
        }

        if (Object.keys(v.shipmentSetObj).length > 0 && v.shipmentSetObj.enableWeight === 'Y') {
          if (weigth !== '') {
            if (weigth > 0) {
              v.scanningPackageData().then(() => {
                handleFun();
              });
            } else {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003997'));
              return false;
            }
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003998'));
            return false;
          }
        } else if (Object.keys(v.shipmentSetObj).length > 0 && v.shipmentSetObj.enableWeight === 'YES') {
          if (v.scannTalg) {
            if (!isValueEmpty(weigth)) {
              handleFun();
            }
          } else {
            v.scanningPackageData().then(() => {
              if (!isValueEmpty(weigth)) {
                handleFun();
              }
            });
          }
        }
      }
    },
    // 处理扫描的数据
    handlerPackage(packageInfo, ymsCarrierHandoverOrderId, originalData, logisticsProviderData) {
      let v = this;
      let hasShippingMethodId = false;
      if (packageInfo.length > 0) {
        packageInfo.forEach(i => {
          v.oeliveryOrderData.forEach(j => {
            if (j.shippingMethodId === i.shippingMethodId) {
              hasShippingMethodId = true;
              // 速卖通全托管
              if (j.carrierCode === 'aliexpressChoice' && j.orderType === 'ONE_STOP_SERVICE') {
                if (j.ymsPlatformAccountId === i.ymsPlatformAccountId) {
                  v.tabsName = i.ymsPlatformAccountId;
                  v.logisticsMode = j.carrierName + '>' + j.shippingMethodName;
                  v.waybillNo = i.trackingNumber;
                  j.data.push({
                    ...JSON.parse(JSON.stringify(i)),
                    shippingMethodId: i.shippingMethodId,
                    carrierName: j.carrierName,
                    shippingMethodName: v.aliExpressLogisticsInfo.carrierShippingMethodName || j.shippingMethodInfo.carrierShippingMethodName || j.shippingMethodName
                  });
                  j.data = this.uniqueFunc(j.data, 'packageCode');
                  v.$forceUpdate();
                } else {
                  hasShippingMethodId = false;
                }
              }
              // 其他物流渠道
              else {
                v.tabsName = i.shippingMethodId;
                v.logisticsMode = j.carrierName + '>' + j.shippingMethodName;
                v.waybillNo = i.trackingNumber;
                j.data.push({
                  ...JSON.parse(JSON.stringify(i)),
                  shippingMethodId: i.shippingMethodId,
                  carrierName: j.carrierName,
                  shippingMethodName: j.shippingMethodName
                });
                if (j.data.length > 0) {
                  j.data.map((k) => {
                    if (k.packageCode === i.packageCode) {
                      k.userWeight = i.userWeight;
                    }
                  });
                }
                if (originalData.shippingMethodId === j.shippingMethodId) {
                  let newList = originalData.ymsCarrierHandoverOrderDetailList || [];
                  let list = [...j.ymsCarrierHandoverOrderDetails, ...newList];
                  j.ymsCarrierHandoverOrderDetails = this.uniqueFunc(list, 'packageCode');
                }

                j.data = this.uniqueFunc(j.data, 'packageCode');
                v.$forceUpdate();
              }
            }
          });
        });
      }
      if (!hasShippingMethodId) {
        if (logisticsProviderData) {
          handleLogisticsProviderFun(logisticsProviderData);
          handleData();
        } else {
          getQueryCarrierShippingName([packageInfo[0].shippingMethodId]).then(data => {
            handleLogisticsProviderFun(data);
            handleData();
          });
        }

        function handleLogisticsProviderFun(data) {
          if (data) {
            v.logisticsMode = data[0].carrierName + '>' + data[0].carrierShippingMethodName;
            v.waybillNo = packageInfo[0].trackingNumber;
            let orderType = packageInfo[0].orderType;
            let carrierCode = data[0].carrierCode;
            let obj = {
              orderType: orderType,
              ymsPlatformAccountId: packageInfo[0].ymsPlatformAccountId,
              shippingMethodId: packageInfo[0].shippingMethodId,
              carrierName: data[0].carrierName,
              ymsCarrierHandoverOrderId: ymsCarrierHandoverOrderId,
              ymsCarrierHandoverOrderDetails: originalData.ymsCarrierHandoverOrderDetailList,
              carrierCode: carrierCode,
              deliveryType: data[0].deliveryType, // 交货方式
              deliveryAddressType: data[0].deliveryAddressType || null,
              data: packageInfo.map(i => {
                i.ymsCarrierHandoverOrderDetails = originalData.ymsCarrierHandoverOrderDetailList;
                i.carrierName = data[0].carrierName;
                i.shippingMethodName = data[0].carrierShippingMethodName;
                return i;
              })
            };
            if (orderType === 'ONE_STOP_SERVICE' && carrierCode === 'aliexpressChoice') {
              v.aliExpressLogisticsInfo = data[0];
              obj.shippingMethodName = packageInfo[0].distributorMerchantId + ' - ' + packageInfo[0].ymsPlatformAccountName;
            } else {
              obj.shippingMethodName = data[0].carrierShippingMethodName;
            }

            v.oeliveryOrderData.push(obj);
            v.tabsName = orderType === 'ONE_STOP_SERVICE' && carrierCode === 'aliexpressChoice' ?
              packageInfo[0].ymsPlatformAccountId : packageInfo[0].shippingMethodId;
            v.carrierCode = data[0].carrierCode;
            v.deliveryType = data[0].deliveryType;
            v.oeliveryOrderData = v.handerOrderAddressData(v.oeliveryOrderData);
            v.$forceUpdate();
          }
        }
      }
      handleData();

      function handleData() {
        let newList = JSON.parse(JSON.stringify(v.oeliveryOrderData));
        setTimeout(() => {
          v.oeliveryOrderData = v.handerOrderAddressData(newList);
        }, 500);
      }
    },
    // 检查扫描包裹中是否存在已取消的订单
    calibrationPackage() {
      this.btnStatus = false;
      this.continueSort = false;
      return new Promise((resolve) => {
        this.axios.get(api.get_ymsPackageInfo_checkScanPackage + `${this.outboundOrder}`).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let processType = data.processType; // 流程类型(1通过校验，2流程停止，3确认后继续物流分拣)
              if (processType === 1) {
                resolve(true);
              } else if (processType === 2) {
                this.btnStatus = true;
                this.$refs['orderCancelPrompt'].basicData = data.checkYmsPickingOrderResults;
                this.$refs['orderCancelPrompt'].orderCancelPromptModal = true;
              } else if (processType === 3) {
                this.continueSort = true;
                this.$refs['orderCancelPrompt'].basicData = data.checkYmsPickingOrderResults;
                this.$refs['orderCancelPrompt'].orderCancelPromptModal = true;
              }
            }
          } else {
            this.formParameter.scanningInput = '';
          }
        });
      });
    },
    // 查询正在处理中的容器数据
    querySortingContainer(value) {
      let v = this;
      v.axios.get(api.get_ymsContainer_querySortingContainer).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.containerCode = data.code;
            let ymsPackageInfoList = data.ymsPackageInfoList || [];
            if (ymsPackageInfoList.length > 0) {
              ymsPackageInfoList.map((item) => {
                item.scanQuantity = 1;
              });
              v.containerData = ymsPackageInfoList;
            }
          } else {
            v.containerCode = '';
            v.containerData = [];
          }
        }
      });
      if (value) {
        v.querySortingCarrierHandoverOrder();
      }
    },
    // 查询当前正在处理的交接单
    querySortingCarrierHandoverOrder() {
      let v = this;
      v.oeliveryOrderData = [];
      v.axios.get(api.get_ymsCarrierHandoverOrder_querySortingCarrierHandoverOrder).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            let shippingMethodIds = [];
            let packages = [];
            let aliExpressFullCustodyList = [];
            let newList = [];
            let ymsPackageInfoData = [];

            function handleData(i, a) {
              i.ymsCarrierHandoverOrderId = a.ymsCarrierHandoverOrderId;
              let obj = {
                ymsPackageId: i.ymsPackageId,
                shippingMethodId: i.shippingMethodId,
                ymsCarrierHandoverOrderDetails: a.ymsCarrierHandoverOrderDetails,
                ymsCarrierHandoverOrderId: a.ymsCarrierHandoverOrderId,
                orderType: i.orderType,
                carrierCode: i.carrierCode,
                carrierName: '',
                shippingMethodName: '',
                ymsPlatformAccountName: i.ymsPlatformAccountName, // 店铺名称
                ymsPlatformAccountId: i.ymsPlatformAccountId,
                distributorMerchantId: i.distributorMerchantId, // 商户号
                packageCode: i.packageCode,
                trackingNumber: i.trackingNumber,
                userWeight: i.userWeight,
                data: [JSON.parse(JSON.stringify(i))]
              };
              return obj;
            }

            data.forEach((a, b) => {
              let ymsPackageInfoList = a.ymsPackageInfoList || [];
              if (ymsPackageInfoList.length > 0) {
                ymsPackageInfoList.forEach(i => {
                  shippingMethodIds.push(i.shippingMethodId);
                  let obj = handleData(i, a);
                  ymsPackageInfoData.push(obj);
                });
              }
            });
            if (shippingMethodIds.length > 0) {
              shippingMethodIds = v.uniqueFunc(shippingMethodIds);
              getQueryCarrierShippingName(shippingMethodIds).then(data => {
                if (data.length > 0) {
                  ymsPackageInfoData.forEach(i => {
                    data.forEach(j => {
                      if (i.shippingMethodId === j.shippingMethodId) {
                        i.carrierName = j.carrierName;
                        i.carrierCode = j.carrierCode;
                        i.deliveryType = j.deliveryType;
                        i.shippingMethodName = j.carrierShippingMethodName;
                        i.deliveryAddressType = j.deliveryAddressType || null;
                        if (!(i.orderType === 'ONE_STOP_SERVICE' && i.carrierCode === 'aliexpressChoice')) {
                          i.data.forEach(k => {
                            k.carrierName = j.carrierName;
                            k.shippingMethodName = j.carrierShippingMethodName;
                          });
                        }
                      }
                    });
                  });
                  ymsPackageInfoData.map((item) => {
                    if (item.orderType === 'ONE_STOP_SERVICE' && item.carrierCode === 'aliexpressChoice') {
                      let {data, ...ele} = item;
                      aliExpressFullCustodyList.push(ele);
                    } else {
                      packages.push(item);
                    }
                  });

                  console.log('---------其他物流渠道----------', packages);
                  console.log('======速卖通全托管======', aliExpressFullCustodyList);

                  // 判断当前是不是在同一个物流渠道下
                  if (packages.length > 0) {
                    let allSameShippingMethodId = packages.every(order => order.shippingMethodId === packages[0].shippingMethodId);
                    if (allSameShippingMethodId) {
                      let combinedData = {};
                      let combinedCarrierDetails = {};
                      packages.map((item, index) => {
                        if (index !== 0) {
                          item.data.forEach(item => {
                            if (!combinedData[item.packageCode]) {
                              combinedData[item.packageCode] = item;
                            }
                          });
                          if (item.ymsCarrierHandoverOrderDetails) {
                            item.ymsCarrierHandoverOrderDetails.forEach(item => {
                              if (!combinedCarrierDetails[item.packageCode]) {
                                combinedCarrierDetails[item.packageCode] = item;
                              }
                            });
                          }
                        }
                      });
                      packages[0].data = packages[0].data.concat(Object.values(combinedData));
                      packages[0].ymsCarrierHandoverOrderDetails = packages[0].ymsCarrierHandoverOrderDetails.concat(Object.values(combinedCarrierDetails)) || [];
                    }
                  }
                  packages = v.uniqueFunc(packages, 'shippingMethodId');
                  // 速卖通全托管 (按照店铺分组)
                  if (aliExpressFullCustodyList.length > 0) {
                    let newObj = {};
                    aliExpressFullCustodyList.map((item) => {
                      let key = item.ymsPlatformAccountId;
                      if (!newObj[key]) {
                        newObj[key] = {
                          ...item,
                          data: []
                        };
                      }
                      newObj[key].data.push(item);
                    });
                    newList = Object.values(newObj);
                    if (newList.length > 0) {
                      let vals = {};
                      newList.map((item) => {
                        data.map(ele => {
                          if (item.shippingMethodId === ele.shippingMethodId) {
                            vals = ele;
                            v.aliExpressLogisticsInfo = ele;
                          }
                        });
                      });
                      if (Object.keys(vals).length > 0) {
                        newList.map((ele) => {
                          ele.carrierName = vals.carrierName;
                          ele.carrierCode = vals.carrierCode;
                          ele.deliveryType = vals.deliveryType;
                          ele.shippingMethodName = ele.distributorMerchantId + ' - ' + ele.ymsPlatformAccountName;
                          ele.shippingMethodInfo = vals;
                          ele.data.forEach(k => {
                            k.carrierName = vals.carrierName;
                            k.shippingMethodName = vals.carrierShippingMethodName;
                          });
                        });
                      }
                    }
                  }
                  if (packages.length <= 0) {
                    v.tabsName = newList[0].ymsPlatformAccountId;
                    v.deliveryType = newList[0].deliveryType;
                  } else {
                    v.tabsName = packages[0].shippingMethodId;
                    v.deliveryType = packages[0].deliveryType;
                  }
                  let newData = [...packages, ...newList];
                  if (newData.length > 0) {
                    v.ymsCarrierHandoverOrderId = newData[0].ymsCarrierHandoverOrderId;
                    v.carrierCode = newData[0].carrierCode;
                    v.deliveryType = newData[0].deliveryType;
                    v.oeliveryOrderData = v.handerOrderAddressData(newData);
                    v.changeTabs(v.tabsName);
                    v.$forceUpdate();
                  }
                }
              });
            }
          } else {
            v.oeliveryOrderData = [];
          }
        }
      });
    },
    // 处理订单地址数据
    handerOrderAddressData(newData) {
      newData.map((item) => {
        item.orderAddressData = [];
        if (item.deliveryAddressType === 2) {
          let newData = this.handerGrouping(item.data, function (ele) {
            return [ele.ymsCarrierHandoverOrderId];
          }, 'ymsCarrierHandoverOrderId', 'addressList');
          item.orderAddressData = newData;
          item.orderAddressTab = newData[0].ymsCarrierHandoverOrderId;
        }
      });
      return newData;
    },
    // 当设置称重的时候，扫描包裹时，要展示物流商
    logistics(data) {
      let v = this;
      let carrierName = '';
      let shippingMethodIds = [data.shippingMethodId];
      return new Promise((resolve) => {
        getQueryCarrierShippingName(shippingMethodIds).then((list) => {
          if (list.length > 0) {
            list.map((ele) => {
              if (ele.shippingMethodId === data.shippingMethodId) {
                carrierName = ele.carrierName + '>' + ele.carrierShippingMethodName;
              }
            });
          }
          v.logisticsMode = carrierName;
          resolve(list);
        });
      });
    },
    // 扫描完成后重置数据
    resetData() {
      if (this.containerCode) {
        this.formParameter.scanningInput = '';
        this.formParameter.weight = null;
      } else {
        this.waybillNo = '';
        this.logisticsMode = '';
        this.formParameter.scanningInput = '';
        this.formParameter.weight = null;
      }
    },
    // 处理结袋
    handleBagMaking(type, obj) {
      let v = this;
      let talg = obj && Object.keys(obj).length > 0;
      let query = {
        type: type, // 结袋类型 0:结袋打印 1:直接结袋 ,
        ymsCarrierHandoverOrderId: v.ymsCarrierHandoverOrderId,
        expressageCode: talg ? obj.expressageCode : null,
        expressageNo: talg ? obj.expressageNo : '',
        orderMethd: talg ? obj.orderMethd : null,
        shippingMethodId: talg ? obj.shippingMethodId : null
      };
      if (v.deliveryType === 1) {
        if (query.shippingMethodId || (query.expressageCode && query.expressageNo)) {
          handleData(query);
        } else {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003999'));
          return false;
        }
      } else {
        handleData(query);
      }

      function handleData(query) {
        v.axios.post(api.post_ymsCarrierHandoverOrder_endSorting, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            v.preDeliverySheetModal = false;
            v.aliExpressFullCustodyModal = false;
            v.$refs['domesticCourierSelect'].domesticCourierSelectModal = false;
            v.querySortingCarrierHandoverOrder();
            // 打印箱唛
            if (data.length > 0) {
              /*快递至揽收点*/
              if (v.deliveryType === 1) {
                handlePrint(data);
              } else {
                // 速卖通
                if (v.carrierCode === 'aliexpress') {
                  /*打印预交面单*/
                  if (type === 0) {
                    v.axios.put(api.put_ymsCarrierHandoverOrder_printHandoverPdfGetr + `${v.ymsCarrierHandoverOrderId}`).then(response => {
                      if (response.data.code === 0) {
                        let datas = response.data.datas;
                        if (datas) {
                          v.commonPrint(datas, '1');
                        }
                      }
                    });
                  } else {
                    v.commonPrint(data[0], '1');
                  }
                }
                // 速卖通全托管
                if (v.carrierCode === 'aliexpressChoice') {
                  if (data.length > 0) {
                    let path1 = data[0];
                    if (path1) {
                      v.commonPrint(path1, '1').then(() => {
                        if (data.length > 1) {
                          let path2 = data[1];
                          if (path2) {
                            v.commonPrint(path2, '1');
                          } else {
                            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000617'));
                            return false;
                          }
                        }
                      });
                    } else {
                      v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000617'));
                      return false;
                    }
                  }
                }
              }
            }

            function handlePrint(data) {
              let path1 = data[0];
              let path2 = data[1];
              if (path1) {
                v.commonPrint(path1, '1').then(() => {
                  if (path2) {
                    v.commonPrint(path2, '1');
                  } else {
                    v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000617'));
                    return false;
                  }
                });
              } else {
                v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000617'));
                return false;
              }
            }
          }
        });
      }
    },
    // 获取结袋的参数--（快递到揽收点）
    updateEndPacking(obj) {
      this.handleBagMaking(0, obj);
    },
    // 结袋操作按钮
    bagMakingBtn() {
      let v = this;
      if (v.oeliveryOrderData.length > 0) {
        if (v.deliveryType === 1) {
          v.$refs['domesticCourierSelect'].initDomesticCourierSelectData();
        } else {
          // 物流商为速卖通线上发货
          if (v.carrierCode === 'aliexpress') {
            v.preDeliverySheetModal = true;
          }
          // 速卖通全托管
          else if (v.carrierCode === 'aliexpressChoice') {
            v.aliExpressFullCustodyModal = true;
          } else {
            v.handleBagMaking(0);
          }
        }
      }
    },
    // 切换tabs
    changeTabs(name) {
      this.tabsName = name;
      let data = null;
      this.oeliveryOrderData.map((item) => {
        if (item.orderType === 'ONE_STOP_SERVICE' && item.carrierCode === 'aliexpressChoice') {
          if (item.ymsPlatformAccountId === name) {
            data = item;
          }
        } else {
          if (item.shippingMethodId === name) {
            data = item;
          }
        }
      });
      if (data) {
        this.ymsCarrierHandoverOrderId = data.ymsCarrierHandoverOrderId;
        this.carrierCode = data.carrierCode;
        this.deliveryType = data.deliveryType;
      }
    },
    // 结束容器分拣
    endContainerSorting(isClose) {
      let v = this;
      // isClose 强制结束: 0否 1是
      v.axios.put(api.put_ymsContainer_closeContainerSorting + v.containerCode + `?isClose=${isClose}`).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.querySortingContainer(false);
        }
      });
    },

    // 结束容器分拣按钮
    endContainerSortingBtn() {
      let v = this;
      if (v.containerData.length > 0) {
        let talg = false;
        let text = '';
        talg = v.containerData.every((item) => {
          return item.isScan === 1;
        });
        if (talg) {
          v.endContainerSorting(0);
        } else {
          text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004000');
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004001'),
            content: text,
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004002'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001251'),
            onOk: () => {
              v.endContainerSorting(1);
            },
            onCancel: () => {
            }
          });
        }
      }
    },
    // 发货设置
    setingBtn() {
      this.getDeliverySettings().then((data) => {
        this.$refs['shipmentSettings'].initShipmentSettingsData(data);
      });
    },
    // 切换订单地址
    orderAddressChange(ele, index) {
      this.$set(this.oeliveryOrderData[index], 'orderAddressTab', ele.ymsCarrierHandoverOrderId);
      this.$forceUpdate();
    }
  },
  components: {
    orderCancelPromptModal,
    domesticCourierSelectModal,
    shipmentSettingsModal
  }
};
</script>

<style lang="less" scoped>
.container_box {
  background-color: #fff;
  padding: 10px;

  .scanning_conter_box {
    .scanning_conter_header {
      display: inline-block;
      line-height: 38px;

      .title {
        color: #333;
        font-size: 16px;
      }

      .options_center {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 19px;

        .options {
          display: flex;
          align-items: center;

          .options_item {
            display: flex;
            align-items: center;
            margin-right: 15px;
            font-size: 14px;
          }

          .icon_yes {
            font-size: 20px;
            color: #008000;
            font-weight: bold;
          }

          .icon_no {
            font-size: 20px;
            color: #FF0000;
            font-weight: bold;
          }

          .help_icon {
            font-size: 21px;
            color: #999999;
            cursor: pointer;
          }

          .icon_set {
            font-size: 21px;
            color: #2D8CF0;
            cursor: pointer;
          }
        }
      }
    }

    .package_box {
      .bill_lading {
        font-size: 22px;
        color: #333;
        margin-bottom: 15px;
        font-weight: bold;
      }

      .logistics_mode {
        font-size: 32px;
        margin-bottom: 15px;

        .tips {
          color: #D9001B;
        }
      }

      .scan_title {
        font-size: 29px;
        color: #333;
        margin-bottom: 15px;
      }

      .options_box {
        width: 100%;
        margin: 0px auto 30px;
        display: flex;

        .form_box {
          padding: 20px 10px;
          background-color: #DBEBD3;
          margin-right: 100px;

          /deep/ input, /deep/ .ivu-input-number {
            height: 38px;
            line-height: 38px;
          }

          /deep/ .ivu-form-item-label {
            font-size: 16px;
            padding-right: 0 !important;
            color: #333;
          }

          /deep/ .ivu-input-number-handler {
            height: 19px;
          }
        }
      }

      .no_scanned {
        .title {
          color: #333;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 10px;

          .tips {
            color: #FF0000;
          }
        }
      }
    }

    .end_sort_btn {
      width: 100%;
      padding: 15px 30px;
      box-sizing: border-box;
      border-top: 1px solid #DCDEE2;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }

  .tabs_conter_box {
    width: 70%;
    max-height: 820px;
    overflow-y: auto;

    /deep/ .ivu-tabs-bar {
      padding: 0;
      margin-bottom: 15px;
      border-bottom: 1px solid #dcdee2;
    }

    .orderAddress_tab_box {
      display: flex;
      align-items: flex-start;
      line-height: initial;

      .orderAddress_tab_item {
        cursor: pointer;
        text-align: center;
        width: 60px;
        margin: 0 15px;
      }
    }

    .active_tab {
      color: #2D8CF0;

      &:after {
        content: ' ';
        display: inline-block;
        width: 100%;
        height: 2px;
        background-color: #2D8CF0;
        position: relative;
        top: -5px;
      }
    }
  }

  .tabs_conter_box .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container,
  .tabs_conter_box .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active,
  .tabs_conter_box .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    height: 45px;
  }

  .options_btn {
    margin: 40px auto 0;
    display: block;
    width: 170px;
  }
}
</style>

<style>
.tabs_conter_box .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container, .tabs_conter_box .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active, .tabs_conter_box .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  height: 45px;
}

.scanning_conter_box .ivu-form-item {
  margin-bottom: 10px;
}

.scanning_conter_box .ivu-form-item:last-child {
  margin-bottom: 0px;
}
</style>